import type { Observable } from 'rxjs/Observable';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch';

export const getUpdateUrl = (projectId: number) =>
	`/rest/servicedesk/1/servicedesk/${projectId}/portal-groups/request-types`;

const updateTicketTypesByGroupRest = (
	projectId: number,
	groupId: number,
	ticketTypeIds: number[],
): Observable<undefined> =>
	fetchJson$(getUpdateUrl(projectId), {
		method: 'POST',
		body: JSON.stringify({ groups: [{ groupId, ticketTypeIds }] }),
	});

export default updateTicketTypesByGroupRest;
